import { GoogleMapsPlaceDetails } from '../../container/shop/GoogleMapsPlaceDetails';
import { StoreAddress } from './StoreAddress';
import { StoreOpeningTimes } from './StoreOpeningTimes';
import React from 'react';
import { Divider, Grid } from '@material-ui/core';
import { ContactMap } from './ContactMap';
import PropTypes from 'prop-types';

export const ContactData = ({ hideMap }) => {
	return (
		<GoogleMapsPlaceDetails.Container>
			<Grid container spacing={2}>
				{!hideMap && (
					<Grid item xs={12}>
						<ContactMap />
					</Grid>
				)}
				<Grid item xs={12}>
					<StoreAddress hidePhoneNumber />
				</Grid>
				<Grid item xs={12}>
					<Divider />
				</Grid>
				<Grid item xs={12}>
					<StoreOpeningTimes />
				</Grid>
			</Grid>
		</GoogleMapsPlaceDetails.Container>
	);
};

ContactData.propTypes = {
	hideMap: PropTypes.bool,
};
ContactData.defaultProps = {
	hideMap: false,
};
